import { bg_accent_emphasis, fg_onEmphasis } from "@clockwise/design-system/tokens";
import { Tooltip, TooltipProps, withStyles } from "@material-ui/core";
import { CalendarCheck, Envelope, ListChecks } from "phosphor-react";
import React from "react";
const InteractiveTooltip: React.FC<TooltipProps> = ({ ...props }) => (
  <Tooltip {...props} interactive tabIndex={0} arrow placement="bottom" />
);

export const FlexMeetingSlideTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: bg_accent_emphasis,
    borderRadius: "10px",
    color: fg_onEmphasis,
    maxWidth: "300px",
    padding: 10,
    cursor: "pointer",
    "@media (min-width: 768px)": {
      padding: 20,
      maxWidth: "400px",
    },
  },
  arrow: {
    color: bg_accent_emphasis,
  },
}))(InteractiveTooltip);

export const TooltipContent = () => {
  return (
    <div className="cw-flex cw-flex-col cw-w-full">
      <div className="cw-flex cw-justify-start cw-py-2">
        <div>
          <CalendarCheck size={20} className="cw-mr-3" color={fg_onEmphasis} />
        </div>
        <div>
          You can relax - Clockwise knows when your coworkers are available to meet, even if they
          aren't Clockwise users or are in a different time zone.
        </div>
      </div>

      <div className="cw-flex cw-justify-start cw-py-2">
        <div>
          <Envelope size={20} className="cw-mr-3" color={fg_onEmphasis} />
        </div>
        <div>
          Once you've made a meeting flexible, we'll send them an email letting them know Clockwise
          may move this meeting to a better time, and explain the why and how.
        </div>
      </div>

      <div className="cw-flex cw-justify-start cw-py-2">
        <div>
          <ListChecks size={20} className="cw-mr-3" color={fg_onEmphasis} />
        </div>
        <div>
          Each time Clockwise moves a meeting, it notifies attendees at least a day in advance and
          preserves all meeting details like attachments and conference links.
        </div>
      </div>
    </div>
  );
};
